module.exports = __webpack_public_path__ + "img/90sheji_linggan_13132416@2x.d3198c37.png";